import React from 'react'
import { IonSkeletonText, IonThumbnail } from '@ionic/react'
import './styles.scss'

export const NewsRadioCardSkeleton = (props) => {
  return (
    <figure className='news-radio-card-skeleton'>
      <IonThumbnail>
        <IonSkeletonText animated />
      </IonThumbnail>
      <figcaption>
        <IonSkeletonText animated />
        <IonSkeletonText animated style={{ width: '50%' }} />
      </figcaption>
    </figure>
  )
}
